<template>
  <div id="app">
    <top-bar />
    <main class="bd-main content">
      <router-view ref="component" />
    </main>
    <Footer />
    <Drawer />
  </div>
</template>

<script>
    import sharedMethodsMixin from '@/mixins/sharedMethodsMixin'
    import Footer from '@/components/Footer.vue'
    import TopBar from '@/components/TopBar.vue'
    import Drawer from '@/components/Drawer.vue'

    export default {
        name: 'home',
        mixins: [sharedMethodsMixin],
        components: {
            Footer, TopBar, Drawer
        },
        data() {
            return {
                collapse: false,
            }
        },
        
        beforeMount() {

        },
        mounted() {

        },
        methods: {

        }
    }
</script>

<style>
</style>
